import appsWithNoHeader from './noHeaderAppList';

// TODO: this data should be moved to the manifest once it's implemented in the backend
const specificAppDataOverride = {
  setValue(keys, prop) {
    keys.forEach((key) => {
      this[key] = { ...this[key], ...prop };
    });
  },
};
// To remove the header for a specific app
specificAppDataOverride.setValue(appsWithNoHeader, { show_header: false });
delete specificAppDataOverride.setValue;

export default specificAppDataOverride;
